import React, { PropTypes, Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styled from 'styled-components';

import {
  NitroHeading,
  NitroSearchBar,
  NitroPlaceholder,
  NitroPanel,
  NitroSingleSelect
} from 'nitro-components';

import { INSIGHTS } from '../../../routes/const';
import { TotalResults } from '../../../components/utils/TableUtils';
import FilterMobileComponent from '../../../components/common/FilterMobileComponent';
import Header from '../../../components/layouts/Header';
import {
  FilterGroup,
  CountryFilter,
  CostcenterFilter
} from '../../../components/filter';
import { SEARCHTYPE } from '../../../features/common/GlobalSearchBar/store/TYPES';
// Update to default role when applying with country change
import { changeCurrentRole } from '../../../auth/actions';
import {
  getCurrentRole,
  getFormatedRoles
} from '../../../components/common/Profile/selector';
import { updateCurrentRole } from '../../../components/common/Profile/utils';
import {
  setGlobalCountryCostCenter,
  setGlobalDynamicFilter
} from '../../../action/CommonActions';

import Breakpoint from '../../../utils/breakpoints';

import * as actions from './actions';
import DriverAllocationGrid from './components/DriverAllocationGrid';
import VehicleDriverDetails from './components/VehicleDriverDetails';
import DriverDetails from './components/DriverDetails';
import AllocateDiffDriverNotify from './components/AllocateDiffDriverNotify';
import AllocateDifferentDriver from './components/AllocateDifferentDriver';

import {
  getDriverAllocation,
  getDriverAllocationCCAndCountry,
  getRestrictionFilter
} from './selector';

const DriverPanel = styled.div`
  width: 100%;
  min-height: 300px;
`;

const Row = styled.div`
  position: relative;
  display: flex;
  margin-bottom: 16px;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
`;
const SingleSelector = styled.div`
  width: 188px;
  margin: 0 8px;
`;

const TABLE_ROW_LIMIT = 15;

let filters = [];
// import { VEHICLE_SEARCH_HINT, RECORD_NUMBER } from "./content";
//
const fetchRouteStateCountryAndCostcenter = routeState => {
  let country;
  let costcenter;
  if (routeState.driverProfile) {
    const { driverProfile } = routeState;
    country = {
      label: driverProfile.CountryName,
      value: driverProfile.CountryCode,
      title: 'Country'
    };
    costcenter = {
      label: driverProfile.CompanyName,
      value: driverProfile.CompanyCode,
      title: 'Cost Centre'
    };
  } else if (routeState.vehicleAllocationData) {
    country = {
      label: routeState.vehicleAllocationData.CountryName,
      value: routeState.vehicleAllocationData.CountryCode,
      title: 'Country'
    };
    costcenter = {
      label: routeState.vehicleAllocationData.CompanyName,
      value: routeState.vehicleAllocationData.CompanyCode,
      title: 'Cost Centre'
    };
  }

  return { country, costcenter };
};

class DriverAllocation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchType: '',
      searchOptions: SEARCHTYPE.map(i => ({ label: i, value: i })),
      searchString: '',
      country: {},
      costcenter: {},
      sortQuery: '',
      currentPage: 0,
      allocationDetailsOpen: false,
      driverDetailsOpen: false,
      allocateDifferentDriverNotifyOpen: false,
      allocateDifferentDriverOpen: false,
      allocateRedirectedDriver: false
    };
  }

  componentDidMount() {
    const { location } = this.props;
    const { country, costcenter } =
      location.state && location.state.vehicleAllocationData
        ? fetchRouteStateCountryAndCostcenter(location.state)
        : this.props;
    this.setFilters([country, costcenter]);

    // Allocate a driver to vehicle from driver dashboard
    // const { location } = this.props;
    const vehicleAllocationData = location.state
      ? location.state.vehicleAllocationData
      : null;

    if (vehicleAllocationData) {
      this.openSidePanel(
        'vehicleAllocation',
        vehicleAllocationData,
        true,
        true
      );
    }
  }

  /** Vehicle Allocation Section -- handles clicks events of vehicle allocation and vehicle allocation side panels. --START* */
  onVehicleAllocationClick = vehicleAllocationRowData => {
    this.openSidePanel(
      'vehicleAllocation',
      vehicleAllocationRowData.props.data,
      true
    );
  };

  /** Allocate different Driver NOTIFY click --START * */
  onAllocateDifferentDriverClick = allocateRedirectedDriver => {
    this.closeSidePanel('vehicleAllocation');
    this.openSidePanel('differentDriverNotify');

    this.setState({
      allocateRedirectedDriver: Boolean(allocateRedirectedDriver.DriverId)
    });
  };

  onAllocateDifferentDriverNotifyContinue = () => {
    this.closeSidePanel('differentDriverNotify');
    this.openSidePanel('differentDriver');
  };
  /** Allocate different Driver NOTIFY click --END * */

  getDrivers = (country, costCentre, currentPage, restrictions) => {
    const page = currentPage;
    const fetchParams = {
      countryCode: country,
      companyCode: costCentre,
      restrictions: JSON.stringify(restrictions),
      offset: page * TABLE_ROW_LIMIT,
      limit: TABLE_ROW_LIMIT,
      lookup: this.state.searchString,
      sort: this.state.sortQuery,
      roleId: this.props.role.value,
      lookupType: this.state.searchType
    };
    this.props.actions.fetchDriverAllocations(fetchParams);
  };

  setFilters = (filters, dynFilters) => {
    if (!filters) return;

    let restrictions = [];
    if (dynFilters) {
      restrictions = dynFilters.map(item => ({
        typeId: item.typeId,
        values: item.value.map(item => item.value)
      }));
    }

    const country = filters[0];
    const costcenter = filters[1];
    this.props.setGlobalCountryCostCenter({ country, costcenter });

    if (this.props.role.country !== country.value) {
      // update role when country is changed in filter
      updateCurrentRole(
        this.props.roles,
        [],
        country.value,
        'ROLEDRAWERCHANGE',
        newRole => {
          this.props.setGlobalDynamicFilter([]);
          this.props.changeCurrentRole(newRole);
          this.context.router.push(INSIGHTS);
        }
      );
    }

    this.setState({
      country,
      costcenter,
      currentPage: 0
    });

    this.getDrivers(country.value, costcenter.value, 0, restrictions);
  };

  fetchGridData = (currentPage, sortQuery) => {
    const rest = this.state.restrictions;
    this.setState(
      {
        sortQuery,
        currentPage
      },
      () => {
        this.getDrivers(filters[0].value, filters[1].value, currentPage);
      }
    );
  };

  openSidePanel = (pageId, payLoad, stateRefresh, fromRoute) => {
    switch (pageId) {
      case 'vehicleAllocation': {
        const vehicleAllocation = payLoad;
        if (stateRefresh) {
          // if coming from route fetch the driverallocation based on state of route
          this.props.actions.fetchDriverAllocationDetails({
            countryCode: fromRoute
              ? vehicleAllocation.CountryCode
              : this.state.country.value,
            companyCode: fromRoute
              ? vehicleAllocation.CompanyCode
              : this.state.costcenter.value,
            id: vehicleAllocation.LeaseId,
            roleId: this.props.role.value
          });
        }
        this.setState({
          allocationDetailsOpen: true,
          vehicleAllocationDetails: vehicleAllocation
        });
        break;
      }

      // Note: To be removed later
      /**   case "currentDriver": {
        const driverId = payLoad;
        if (
          this.props.driverDetails &&
          this.props.driverDetails.DriverId === driverId
        ) {
          //Cached driver details, no need to refetch the details, since details present in store.
        } else {
          this.props.actions.fetchDriverDetails(
            {
              countryCode: this.state.country.value,
              companyCode: this.state.costcenter.value
            },
            driverId
          );
        }
        this.setState({
          driverDetailsOpen: true
        });
        break;
      }* */

      case 'differentDriverNotify': {
        this.setState({
          allocateDifferentDriverNotifyOpen: true
        });
        break;
      }

      case 'differentDriver': {
        this.setState({
          allocateDifferentDriverOpen: true
        });
        break;
      }

      default: {
        console.error('invalid pageId');
        throw 'invalid pageId';
        break;
      }
    }
  };

  closeSidePanel = pageId => {
    switch (pageId) {
      case 'vehicleAllocation': {
        this.setState({
          allocationDetailsOpen: false
        });
        break;
      }
      case 'currentDriver': {
        this.setState({
          driverDetailsOpen: false
        });
        break;
      }
      case 'differentDriverNotify': {
        this.setState({
          allocateDifferentDriverNotifyOpen: false
        });
        break;
      }

      case 'differentDriver': {
        this.setState({
          allocateDifferentDriverOpen: false
        });
        break;
      }

      default: {
        console.error('invalid pageId');
        throw 'invalid pageId';
        break;
      }
    }
  };

  backSidePanel = pageId => {
    switch (pageId) {
      // Note: To be removed later
      /**   case "currentDriver": {
        this.closeSidePanel("currentDriver");
        this.openSidePanel(
          "vehicleAllocation",
          this.state.vehicleAllocationDetails,
          false
        );
        break;
      }* */
      case 'differentDriverNotify': {
        this.closeSidePanel('differentDriverNotify');
        this.openSidePanel(
          'vehicleAllocation',
          this.state.vehicleAllocationDetails,
          false
        );
        break;
      }

      case 'differentDriver': {
        this.closeSidePanel('differentDriver');
        this.openSidePanel(
          'vehicleAllocation',
          this.state.vehicleAllocationDetails,
          false
        );
        break;
      }

      default: {
        console.error('invalid pageId');
        throw Error('invalid pageId');
        break;
      }
    }
  };

  /** Vehicle Allocation Section -- END* */

  search = text => {
    this.setState(
      {
        searchString: text.toLowerCase(),
        currentPage: 0
      },
      () => {
        this.getDrivers(filters[0].value, filters[1].value, 0);
      }
    );
  };

  /** Driver Details Section -- handles click events of driver details  and driver detail side panels. --START* */
  /** onCurrentDriverPanelClick = driverId => {
    this.closeSidePanel("vehicleAllocation");
    this.openSidePanel("currentDriver", driverId, true);
  };* */
  /** Driver Details Section -- END* */

  render() {
    const { currentPage } = this.state;

    const { fetchingDrivers, location } = this.props;

    const { country, costcenter } = this.props;

    const driverProfile = location.state ? location.state.driverProfile : null;

    filters = [
      {
        title: 'Country',
        component: CountryFilter,
        ...country
      },
      {
        title: 'Cost Centre',
        component: CostcenterFilter,
        ...costcenter
      }
    ];

    return (
      <section>
        <Header>
          <NitroHeading label="Driver Allocation" header />
          <Breakpoint name="desktop">
            <FilterGroup
              width="80%"
              action={this.setFilters}
              title="Source"
              icon="source"
              filters={filters}
              align="right"
            />
          </Breakpoint>
          <Breakpoint name="mobileTablet">
            <FilterMobileComponent
              onClickSource={this.setFilters}
              source={filters}
            />
          </Breakpoint>
        </Header>

        <NitroPanel padding="32px">
          <DriverPanel>
            {!fetchingDrivers && (
              <TotalResults
                total={this.props.totalDrivers}
                currentPage={currentPage}
                limit={TABLE_ROW_LIMIT}
                pageCount={this.props.driverList.length}
              />
            )}
            <Row>
              <SingleSelector>
                <NitroSingleSelect
                  value={this.state.searchType}
                  options={this.state.searchOptions}
                  placeholder="Select Search Type"
                  action={data => {
                    this.setState({ searchType: data.value });
                  }}
                />
              </SingleSelector>
              <NitroSearchBar
                float="right"
                hintText="Search registration, vehicle, Lease ID or driver"
                action={this.search}
                width={350}
              />
            </Row>

            <NitroPlaceholder size={24} />

            {/* Performance improvement for the DriverAllocation grid - Dont rerender the allocation grid for any drawer change - utilize the shouldNotReRender flag */}
            <DriverAllocationGrid
              data={this.props.driverList}
              total={this.props.totalDrivers}
              getExternalData={this.fetchGridData}
              rowCount={TABLE_ROW_LIMIT}
              onRowClick={this.onVehicleAllocationClick}
              currentPage={this.state.currentPage}
              dataFetching={this.props.fetchingDrivers}
              shouldNotReRender={
                this.state.allocationDetailsOpen ||
                this.state.driverDetailsOpen ||
                this.state.allocateDifferentDriverNotifyOpen ||
                this.state.allocateDifferentDriverOpen
              }
            />
          </DriverPanel>
        </NitroPanel>

        <VehicleDriverDetails
          isOpen={this.state.allocationDetailsOpen}
          close={this.closeSidePanel}
          driverAllocationDetails={this.props.driverAllocationDetails}
          fetchingDriverAllocationDetails={
            this.props.fetchingDriverAllocationDetails
          }
          onAllocateDifferentDriverClick={this.onAllocateDifferentDriverClick}
          //  onCurrentDriverPanelClick={this.onCurrentDriverPanelClick}
          country={country}
          redirectedDriverProfile={driverProfile}
        />

        <DriverDetails
          isOpen={this.state.driverDetailsOpen}
          close={this.closeSidePanel}
          back={this.backSidePanel}
          details={this.props.driverDetails}
          fetchingDriverDetails={this.props.fetchingDriverDetails}
        />

        {this.state.allocateDifferentDriverNotifyOpen && (
          <AllocateDiffDriverNotify
            isOpen={this.state.allocateDifferentDriverNotifyOpen}
            close={this.closeSidePanel}
            back={this.backSidePanel}
            allocateDiffDriverNotifyContinue={
              this.onAllocateDifferentDriverNotifyContinue
            }
          />
        )}

        {this.state.vehicleAllocationDetails && (
          <AllocateDifferentDriver
            isOpen={this.state.allocateDifferentDriverOpen}
            close={this.closeSidePanel}
            back={this.backSidePanel}
            vehicleDetails={this.state.vehicleAllocationDetails}
            country={country}
            company={costcenter}
            driverProfile={
              this.state.allocateRedirectedDriver ? driverProfile : null
            }
          />
        )}
      </section>
    );
  }
}

DriverAllocation.propTypes = {
  country: PropTypes.shape({}).isRequired,
  costcenter: PropTypes.shape({}).isRequired,
  actions: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({}).isRequired,
  driverList: PropTypes.arrayOf(),
  totalDrivers: PropTypes.number,
  fetchingDrivers: PropTypes.bool,
  fetchingDriverAllocationDetails: PropTypes.bool,
  driverAllocationDetails: PropTypes.shape({}),
  driverDetails: PropTypes.shape({}),
  fetchingDriverDetails: PropTypes.bool,
  setGlobalCountryCostCenter: PropTypes.func,
  setGlobalDynamicFilter: PropTypes.func
};

DriverAllocation.contextTypes = {
  router: PropTypes.shape({})
};

const mapStateToProps = state => {
  const { costcenter, country } = getDriverAllocationCCAndCountry(state);
  const { restrictions } = getRestrictionFilter(state);

  const {
    fetchingDrivers,
    driverList,
    totalDrivers,
    fetchingDriverAllocationDetails,
    driverAllocationDetails,
    fetchingDriverDetails,
    driverDetails
  } = getDriverAllocation(state);

  return {
    country,
    costcenter,
    totalDrivers,
    driverAllocationDetails,
    driverDetails,
    driverList,
    fetchingDriverAllocationDetails,
    fetchingDriverDetails,
    fetchingDrivers,
    restrictions,
    role: getCurrentRole(state),
    roles: getFormatedRoles(state)
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
  changeCurrentRole: bindActionCreators(changeCurrentRole, dispatch),
  setGlobalCountryCostCenter: bindActionCreators(
    setGlobalCountryCostCenter,
    dispatch
  ),
  setGlobalDynamicFilter: bindActionCreators(setGlobalDynamicFilter, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(DriverAllocation);



// WEBPACK FOOTER //
// ./src/features/relocations/driver/DriverAllocation.js